import { DtPrefs } from '../preferences/DtPreferenceNames';
import { isWebGPUSupportedCached } from '../../compat';

import { av, ave } from "@adsk/lmv";

let { ViewerSettingsPanel, ViewerSettingTab } = ave;
const { ESCAPE_EVENT, VIEWER_RESIZE_EVENT } = av;

// We need to proxy some gui classes for the node build, because the LMV node bundle does not contain them.
// It would be cleaner to exclude this class from our node build, but that would require even more patching.
if (BUILD_FLAG__IS_NODE) {
  class ProxyClass {};
  ViewerSettingsPanel = ProxyClass;
  ViewerSettingTab = ProxyClass;
}

// Shrink settings panel vertically so it does not appear underneath the timeline by default.
const VERTICAL_INSET = 130; // px

// TODO-LMV: Add test that verifies the existence and correct position of our custom options.

// This customizes the settings panel to our needs, by removing some options that we don't want to expose in Tandem,
// as well as adding custom options that don't exist in LMV.
// We also register a resize and escape key handler, that would usually be defined by the GuiViewer,
// which we don't use in Tandem.
export class DtViewerSettingsPanel extends ViewerSettingsPanel {
  constructor(viewer) {
    // The LMV constructor expects a model instance.
    // We provide a fake model with only the required proxy methods.
    const fakeModel = { is2d: () => false, getDocumentNode: () => undefined };

    // Also set the SDK version in the viewer config, because the settings panel picks it up from there.
    viewer.config.viewerVersion = DT_SDK_VERSION;

    super(viewer, fakeModel);

    this.container.style.top = VERTICAL_INSET + 'px';

    // Remove options that we don't want to expose in Tandem.
    if (this.clearOpfsCacheBtnId) {
      this.removeButton(this.clearOpfsCacheBtnId);
    }

    if (this.fusionStyleOrbitChkBoxId) {
      this.removeCheckbox(this.fusionStyleOrbitChkBoxId);
    }

    // Add Tandem-specific options.
    this.enableModelCacheChkBoxId = this.addCheckbox(ViewerSettingTab.Configuration, "Enable model data cache",
    "Reduces network traffic and may improve model load times. Requires a page reload to take effect.",
    true, undefined, DtPrefs.ENABLE_MODEL_CACHE, { insertAtIndex: 4 }
    );

    this.displayObjectInfoId = this.addCheckbox(ViewerSettingTab.Configuration, 'Display Object Info',
    'Shows information about the object under the mouse cursor',
    true, null, DtPrefs.DISPLAY_OBJECT_INFO, { insertAtIndex: isWebGPUSupportedCached() ? 8 : 7 }
    );

    this.options.getViewerDimensions = viewer.getDimensions.bind(viewer);
  }

  addCheckbox(tabId, name, description, initialState, onchange, saveKey, options) {
    // Remove the betaLabel option that LMV sets on some checkboxes.
    if (options && options.betaLabel === true) {
      options.betaLabel = undefined;
    }

    return super.addCheckbox(tabId, name, description, initialState, onchange, saveKey, options);
  }

  sizeToContent() {
    var csize = this.getContentSize();
    var cHeight = csize.height + this.heightAdjustment;
    var maxHeight = this.parentContainer.clientHeight - 2 * VERTICAL_INSET;
    var minSize = Math.min(cHeight, maxHeight);
    this.container.style.height = parseInt(minSize) + 'px';
  }

  _resizeViewerSettingsPanel() {
    var dimensions = this.options.getViewerDimensions();

    var viewerRect = this.options.container.getBoundingClientRect(),
      vt = viewerRect.top,
      vl = viewerRect.left,
      vr = viewerRect.right,
      vw = dimensions.width,
      vh = dimensions.height,
      vb = vt + vh;

    this.onViewerResize(vt, vb, vl, vr, vw, vh);
  }

  _onEscapeKey() {
    if (this.visible) {
      this.setVisible(false);
    }
  }

  /**
   * Adds event listeners for escape and resize events
   */
  addEventListeners = function () {
    this.options.addEventListener(VIEWER_RESIZE_EVENT, this._resizeViewerSettingsPanel.bind(this));
    this.options.addEventListener(ESCAPE_EVENT, this._onEscapeKey.bind(this));
  };
}